import { SpecimenVideo } from "./SpecimenVideo";
import { PetriDish } from "./PetriDish";

export const Stage = ({ phase, progress, countdown, onStart }) => (
  <div className="panel relative h-full overflow-hidden flex items-center justify-center" data-testid="main-stage">
    <SpecimenVideo phase={phase} progress={progress} />
    {phase === "complete" && (
      <div className="absolute inset-x-0 bottom-10 top-[30%] dish-in" data-testid="petri-dish-view">
        <PetriDish />
      </div>
    )}

    {phase === "idle" && (
      <div className="absolute top-10 left-10 text-left pointer-events-none" data-testid="project-title">
        <div className="overline">The Darkness Project</div>
        <div className="big-text-sm text-[#B57BFF] mt-1">EXPERIMENT SPORE</div>
      </div>
    )}

    {phase === "idle" && (
      <button data-testid="spacebar-trigger-button" onClick={onStart} className="start-btn absolute bottom-10 left-1/2 -translate-x-1/2">
        PRESS <span className="kbd">SPACE</span> TO INITIATE CONCEPT UPLOAD
      </button>
    )}

    {phase === "init" && <div data-testid="authorizing-text" className="big-text text-[#FF9900] blink">AUTHORIZING…</div>}

    {phase === "uploading" && (
      <div className="absolute bottom-10 left-10 right-10" data-testid="concept-upload-progress">
        <div className="big-text-sm text-[#00F0FF] glitch mb-4">CONCEPT UPLOADING</div>
        <div className="progress-track">
          <div className="progress-fill" style={{ width: `${progress * 100}%` }} />
        </div>
        <div className="flex justify-between font-mono text-xs mt-2 text-[#00F0FF]/80">
          <span>{progress === 0 ? "ESTABLISHING HANDSHAKE…" : "STREAMING CONCEPT PACKETS"}</span>
          <span data-testid="upload-percent">{Math.round(progress * 100)}%</span>
        </div>
      </div>
    )}

    {phase === "complete" && (
      <>
        <div className="absolute top-8 left-10 right-10 text-center" data-testid="upload-complete-text">
          <div className="big-text-sm text-[#F0F6FC]">UPLOAD COMPLETE</div>
          <div className="big-text text-[#00FF88] mt-1">PETRI DISH READY</div>
        </div>
        <div data-testid="countdown-timer-display" className="absolute bottom-8 left-1/2 -translate-x-1/2 font-mono text-xs tracking-[0.3em] text-[#8B949E]">
          RE-CONTAINMENT IN <span className="text-[#00FF88]">{String(countdown).padStart(2, "0")}</span>s
        </div>
      </>
    )}
  </div>
);
